import { useState } from 'react';

import type { BookingRefundDestination } from '@/types';

import { useCancelBookingReservationMutation } from '@/mutations';

import { notifyBookingSuccess, notifyMutationError } from '@/helpers';

import { useMissedCommentDialog } from '../MissedCommentDialog';

type UseRegistrationActionsParams = {
  reservationsUrl: string;
  onChange: () => void;
};

export const useRegistrationActions = (
  params: UseRegistrationActionsParams,
) => {
  const { reservationsUrl, onChange } = params;

  const [cancelledRegistrationId, setCancelledRegistrationId] = useState<
    number | null
  >(null);

  const missedComment = useMissedCommentDialog({
    reservationsUrl,
    onMarked: onChange,
    onEdited: onChange,
  });
  const { mutate: cancelRegistration, isPending: isCancelPending } =
    useCancelBookingReservationMutation();

  const onCancelConfirm = (data: BookingRefundDestination) => {
    if (!cancelledRegistrationId) {
      return;
    }
    cancelRegistration(
      { url: `${reservationsUrl}/${cancelledRegistrationId}`, data },
      {
        onSuccess: (response) => {
          notifyBookingSuccess(response);
          setCancelledRegistrationId(null);
          onChange();
        },
        onError: notifyMutationError,
      },
    );
  };

  return {
    missedComment,
    cancelledRegistrationId,
    isCancelPending,
    isPending: missedComment.isPending || isCancelPending,
    onCancelOpen: setCancelledRegistrationId,
    onCancelClose: () => setCancelledRegistrationId(null),
    onCancelConfirm,
  };
};
